export { diffHash }





function diffHash(diff) {
    // cannot use hashify: will change "undefined" values to "true"
    return diff.reduce( 
        (diff, item) => { diff[item.attrName] = item.newValue; return diff; }, {} );
}



// WEBPACK FOOTER //
// ./src/js/model/diff.js